import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClubPublicationService {
    public mentionOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public get isMentionOpened() {
        return this.mentionOpened.getValue();
    }

    public setMentionOpened(isOpen: boolean) {
        this.mentionOpened.next(isOpen);
    }
}
